import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from './config';
import { getAxiosBaseUrl } from '../lib/util';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({
    baseUrl: getAxiosBaseUrl() ?? '',
  }),
  endpoints: builder => ({})
});